import AppLayout from '../components/layouts/AppLayout.vue';
import BaseRouterView from '../components/router-views/BaseRouterView.vue';

// Pages
import CampaignRouterView from '../components/router-views/CampaignRouterView.vue';
import ProposalRouterView from '../components/router-views/ProposalRouterView.vue';
import ProposalCompensationRouterView from '../components/router-views/ProposalCompensationRouterView.vue';
import ProposalProductsRouterView from '../components/router-views/ProposalProductsRouterView.vue';
import ProposalTasksRouterView from '../components/router-views/ProposalTasksRouterView.vue';
import ProposalNetworksRouterView from '../components/router-views/ProposalNetworksRouterView.vue';
import ProposalShippingRouterView from '../components/router-views/ProposalShippingRouterView.vue';
import ProposalPersonalInfoRouterView from '../components/router-views/ProposalPersonalInfoRouterView.vue';
import ProposalAssetsRouterView from '../components/router-views/ProposalAssetsRouterView.vue';
import ProposalAgreementsRouterVue from '../components/router-views/ProposalAgreementsRouterVue.vue';
import ProductSelectionProductsRouterView from '../components/router-views/ProductSelectionProductsRouterView.vue';
import ProductSelectionProductRouterView from '../components/router-views/ProductSelectionProductRouterView.vue';
import AboutGrinRouterView from '../components/router-views/AboutGrinRouterView.vue';
import ProposalNetworksFaqRouterView from '../components/router-views/ProposalNetworksFaqRouterView.vue';
import ConnectNetworkRouterView from '../components/router-views/ConnectNetworkRouterView.vue';
import TaskDeliveryInstagramStoryRouterView from '../components/router-views/TaskDeliveryInstagramStoryRouterView.vue';
import AccountVerificationRouterView from '../components/router-views/AccountVerificationRouterView.vue';
import ProposalTaskDeliveryRouterView from '../components/router-views/ProposalTaskDeliveryRouterView.vue';
import AccountVerificationEmailSentRouterView from '../components/router-views/AccountVerificationEmailSentRouterView.vue';
import ActivationBriefProductsRouterView from '../components/router-views/ActivationBriefProductsRouterView.vue';
import ActivationBriefRouterView from '../components/router-views/ActivationBriefRouterView.vue';
import ActivationBriefOverviewRouterView from '../components/router-views/ActivationBriefOverviewRouterView.vue';
import ActivationBriefAgreementsRouterView from '../components/router-views/ActivationBriefAgreementsRouterView.vue';
import ActivationBriefAssetsRouterView from '../components/router-views/ActivationBriefAssetsRouterView.vue';
import ActivationBriefPersonalInfoRouterView from '../components/router-views/ActivationBriefPersonalInfoRouterView.vue';
import ActivationBriefShippingRouterView from '../components/router-views/ActivationBriefShippingRouterView.vue';
import ActivationBriefTasksRouterView from '../components/router-views/ActivationBriefTasksRouterView.vue';
import ActivationBriefPaymentsRouterView from '../components/router-views/ActivationBriefPaymentsRouterView.vue';
import ActivationBriefNetworksRouterView from '../components/router-views/ActivationBriefNetworksRouterView.vue';
import ActivationBriefNetworksFaqRouterView from '../components/router-views/ActivationBriefNetworksFaqRouterView.vue';
import ActivationBriefConnectNetworkRouterView from '../components/data-views/activation-briefs/partials/networks/ActivationBriefConnectNetworkRouterView.vue';
import ActivationBriefTaskDeliveryRouterView from '../components/router-views/ActivationBriefTaskDeliveryRouterView.vue';
import ActivationBriefTaskDeliveryInstagramStoryRouterView from '../components/router-views/ActivationBriefTaskDeliveryInstagramStoryRouterView.vue';
import ActivationDeliverableContentApprovalRouterView from '../components/router-views/ActivationDeliverableContentApprovalRouterView.vue';
import ActivationDeliverablesRouterView from '../components/router-views/ActivationDeliverablesRouterView.vue';
import ActivationBriefConnectNetworkFailedRouterView from '../components/router-views/ActivationBriefConnectNetworkFailedRouterView.vue';
import ActivationBriefOrdersListRouterView from '../components/router-views/ActivationBriefOrdersListRouterView.vue';
import ActivationBriefOrderRouterView from '../components/router-views/ActivationBriefOrderRouterView.vue';
import ActivationTasksSummaryRouterView from '../components/router-views/ActivationTasksSummaryRouterView.vue';
import TaskDeliveryCustomRouterView from '../components/router-views/TaskDeliveryCustomRouterView.vue';
import CampaignConnectNetworkFailedRouterView from '../components/router-views/CampaignConnectNetworkFailedRouterView.vue';
import ConnectNetworkFailedRouterView from '../components/router-views/ConnectNetworkFailedRouterView.vue';
import ActivationBriefAffiliateLinksRouterView from '../components/router-views/ActivationBriefAffiliateLinksRouterView.vue';
import ActivationBriefDeliveryPageRedirectionView from '../components/router-views/ActivationBriefDeliveryPageRedirectorView.vue';
import ActivationContentMetricsRouterView from '../components/router-views/ActivationContentMetricsRouterView.vue';
import ActivationDeliveredContentRouterView from '../components/router-views/ActivationDeliveredContentRouterView.vue';
import ActivationBriefProposalsRouterView from '../components/router-views/ActivationBriefProposalsRouterView.vue';

export default {
    path: '/:live_url([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/v2',
    component: AppLayout,
    children: [
        {
            //@TODO: move to v3 space
            path: 'activation-brief/:brief_id',
            component: BaseRouterView,
            children: [
                {
                    name: 'v2.activation.brief',
                    path: '/',
                    component: ActivationBriefRouterView
                },
                {
                    name: 'v2.activation.brief.overview',
                    path: 'overview',
                    component: ActivationBriefOverviewRouterView
                },
                //TODO: steps routes here
                {
                    name: 'v2.activation.brief.products',
                    path: 'products',
                    component: ActivationBriefProductsRouterView,
                    props: true
                },
                {
                    name: 'v2.activation.brief.personalInfo',
                    path: 'personal-info',
                    component: ActivationBriefPersonalInfoRouterView
                },
                {
                    name: 'v2.activation.brief.agreements',
                    path: 'agreements',
                    component: ActivationBriefAgreementsRouterView
                },
                {
                    name: 'v2.activation.brief.assets',
                    path: 'assets',
                    component: ActivationBriefAssetsRouterView
                },
                {
                    path: 'networks',
                    component: BaseRouterView,
                    children: [
                        {
                            name: 'v2.activation.brief.networks',
                            path: '/',
                            component: ActivationBriefNetworksRouterView
                        },
                        {
                            name: 'v2.activation.brief.networks.faq',
                            path: 'faq',
                            component: ActivationBriefNetworksFaqRouterView
                        },
                        {
                            name: 'v2.activation.brief.networks.network',
                            path: 'network',
                            component: ActivationBriefConnectNetworkRouterView
                        },
                        {
                            name: 'v2.activation.brief.networks.failed',
                            path: ':network/error',
                            component: ActivationBriefConnectNetworkFailedRouterView
                        }
                    ]
                },
                {
                    name: 'v2.activation.brief.payments',
                    path: 'payments',
                    component: ActivationBriefPaymentsRouterView
                },
                {
                    name: 'v2.activation.brief.shipping',
                    path: 'shipping',
                    component: ActivationBriefShippingRouterView,
                    props: true
                },
                {
                    name: 'v2.activation.brief.tasks',
                    path: 'tasks',
                    component: ActivationBriefTasksRouterView
                },
                {
                    path: 'orders',
                    component: BaseRouterView,
                    children: [
                        {
                            name: 'v2.activation.brief.orders',
                            path: '/',
                            component: ActivationBriefOrdersListRouterView
                        },
                        {
                            name: 'v2.activation.brief.order',
                            path: ':order_id',
                            component: ActivationBriefOrderRouterView
                        }
                    ]
                },
                {
                    path: 'task/:task_id',
                    component: BaseRouterView,
                    children: [
                        {
                            path: 'redirect',
                            name: 'v2.activation.brief.task.delivery.redirection',
                            component: ActivationBriefDeliveryPageRedirectionView,
                            children: [
                                {
                                    name: 'v2.activation.brief.task.delivery.redirection',
                                    path: 'deliverable/:deliverable_id',
                                    component: ActivationBriefDeliveryPageRedirectionView
                                }
                            ]
                        },
                        {
                            name: 'v2.activation.brief.task.deliverables',
                            path: 'deliverables',
                            component: ActivationDeliverablesRouterView
                        },
                        {
                            path: 'deliverable/:deliverable_id',
                            component: BaseRouterView,
                            children: [
                                {
                                    name: 'v2.activation.brief.task.deliverable',
                                    path: '/',
                                    component: ActivationDeliverableContentApprovalRouterView
                                },
                                {
                                    path: 'delivery',
                                    component: BaseRouterView,
                                    children: [
                                        {
                                            name: 'v2.activation.brief.task.deliverable.delivery',
                                            path: '/',
                                            component: ActivationBriefTaskDeliveryRouterView
                                        },
                                        {
                                            name: 'v2.activation.brief.task.deliverable.delivery.story',
                                            path: 'story',
                                            component: ActivationBriefTaskDeliveryInstagramStoryRouterView
                                        },
                                        {
                                            name: 'v2.activation.brief.task.deliverable.delivery.custom',
                                            path: 'custom',
                                            component: TaskDeliveryCustomRouterView
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'delivery',
                            component: BaseRouterView,
                            children: [
                                {
                                    name: 'v2.activation.brief.task.delivery',
                                    path: '/',
                                    component: ActivationBriefTaskDeliveryRouterView
                                },
                                {
                                    name: 'v2.activation.brief.task.delivery.story',
                                    path: 'story',
                                    component: ActivationBriefTaskDeliveryInstagramStoryRouterView
                                },
                                {
                                    name: 'v2.activation.brief.task.delivery.custom',
                                    path: 'custom',
                                    component: TaskDeliveryCustomRouterView
                                }
                            ]
                        },
                        {
                            path: 'content',
                            component: BaseRouterView,
                            children: [
                                {
                                    name: 'v2.activation.brief.task.content',
                                    path: '/',
                                    component: ActivationDeliveredContentRouterView
                                },
                                {
                                    name: 'v2.activation.brief.task.content.metrics',
                                    path: ':content_id/metrics',
                                    component: ActivationContentMetricsRouterView
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'v2.activation.brief.links',
                    path: 'links',
                    component: ActivationBriefAffiliateLinksRouterView
                },
                {
                    path: 'redirect',
                    name: 'v2.activation.brief.redirect',
                    component: ActivationBriefDeliveryPageRedirectionView
                },
                {
                    path: 'content/:content_id',
                    component: BaseRouterView,
                    children: [
                        {
                            name: 'v2.activation.brief.content.metrics',
                            path: 'metrics',
                            component: ActivationContentMetricsRouterView
                        }
                    ]
                }
            ]
        },
        {
            name: 'v2.activation.proposals',
            path: 'activations/:activation_id/proposals',
            component: ActivationBriefProposalsRouterView
        },
        {
            name: 'v2.activation.tasks.summary',
            path: 'activation-tasks-summary',
            component: ActivationTasksSummaryRouterView
        },
        {
            name: 'v2.campaign',
            path: 'campaigns/:campaign_id',
            component: CampaignRouterView
        },
        {
            path: 'campaigns/:campaign_id/proposals/:proposal_id',
            component: BaseRouterView,
            children: [
                {
                    name: 'v2.campaign.proposal',
                    path: '/',
                    component: ProposalRouterView
                },
                {
                    name: 'v2.campaign.proposal.compensation',
                    path: 'compensation',
                    component: ProposalCompensationRouterView
                },
                {
                    name: 'v2.campaign.proposal.products',
                    path: 'products',
                    component: ProposalProductsRouterView
                },
                {
                    name: 'v2.campaign.proposal.tasks',
                    path: 'tasks',
                    component: ProposalTasksRouterView
                },
                {
                    path: 'networks',
                    component: BaseRouterView,
                    children: [
                        {
                            name: 'v2.campaign.proposal.networks',
                            path: '/',
                            component: ProposalNetworksRouterView
                        },
                        {
                            name: 'v2.campaign.proposal.networks.faq',
                            path: 'faq',
                            component: ProposalNetworksFaqRouterView
                        },
                        {
                            name: 'v2.campaign.proposal.networks.network',
                            path: 'network',
                            component: ConnectNetworkRouterView
                        },
                        {
                            name: 'v2.campaign.proposal.networks.failed',
                            path: ':network/error',
                            component: CampaignConnectNetworkFailedRouterView
                        }
                    ]
                },
                {
                    name: 'v2.campaign.proposal.shippingInfo',
                    path: 'shipping',
                    component: ProposalShippingRouterView
                },
                {
                    name: 'v2.campaign.proposal.personalInfo',
                    path: 'information',
                    component: ProposalPersonalInfoRouterView
                },
                {
                    name: 'v2.campaign.proposal.assets',
                    path: 'assets',
                    component: ProposalAssetsRouterView
                },
                {
                    name: 'v2.campaign.proposal.agreements',
                    path: 'agreements',
                    component: ProposalAgreementsRouterVue
                },
                {
                    name: 'v2.productSelection',
                    path: 'product-selection',
                    component: BaseRouterView,
                    children: [
                        {
                            name: 'v2.productSelection.products',
                            path: 'products',
                            component: ProductSelectionProductsRouterView
                        },
                        {
                            name: 'v2.productSelection.product',
                            path: 'products/:product_id',
                            component: ProductSelectionProductRouterView
                        }
                    ]
                },
                {
                    path: 'task/:task_id/delivery',
                    component: BaseRouterView,
                    children: [
                        {
                            name: 'v2.campaign.proposal.task.delivery',
                            path: '/',
                            component: ProposalTaskDeliveryRouterView
                        },
                        {
                            name: 'v2.campaign.proposal.task.delivery.story',
                            path: 'story',
                            component: TaskDeliveryInstagramStoryRouterView
                        }
                    ]
                }
            ]
        },
        {
            path: 'dashboard',
            component: BaseRouterView,
            children: [
                {
                    name: 'v2.account.verify',
                    path: 'account/verify',
                    component: AccountVerificationRouterView
                },
                {
                    name: 'v2.account.verify.email.sent',
                    path: 'account/verify/check/email',
                    component: AccountVerificationEmailSentRouterView
                },
                {
                    name: 'v2.manage.networks.failed',
                    path: 'networks/failed',
                    component: ConnectNetworkFailedRouterView
                }
            ]
        },
        {
            name: 'v2.aboutGrin',
            path: 'about-grin',
            component: AboutGrinRouterView
        }
    ]
};
